import { Link, useParams } from "react-router-dom";
import { INFO_CONTENT } from "@/data/infoContent";

export default function InfoPage() {
  const { slug } = useParams();
  const page = INFO_CONTENT[slug];

  if (!page)
    return (
      <div className="mx-auto max-w-[760px] px-5 py-28 md:px-10" data-testid="info-not-found">
        <h1 className="font-display text-4xl text-ink">Halaman tidak ditemukan</h1>
        <Link to="/" className="link-underline mt-8 inline-block text-[12px] uppercase tracking-[0.18em] text-ink">
          Kembali ke Beranda
        </Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 lg:px-16 lg:py-24" data-testid={`info-page-${slug}`}>
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="label-eyebrow text-sand">{page.eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink lg:text-5xl">{page.title}</h1>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <p className="text-lg leading-relaxed text-ink/80">{page.lead}</p>
          <div className="mt-14 space-y-12 border-t border-line pt-12">
            {page.sections.map((s) => (
              <section key={s.heading}>
                <h2 className="font-display text-2xl text-ink">{s.heading}</h2>
                <p className="mt-3 text-base leading-relaxed text-stone">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
